module.exports = __webpack_public_path__ + "img/chaussettevert_off.6b8b5364.gif";